import * as React from 'react';
import { SVGProps } from 'react';

const IconRouteSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5.873 4.957 6.932 6l1.523-5-5.078 1.5 1.06 1.043-1.498 1.474a3.124 3.124 0 0 0 0 4.466 3.243 3.243 0 0 0 4.536 0l2.92-2.875a.932.932 0 0 1 1.304 0c.36.355.36.93 0 1.284l-2.438 2.4a3.036 3.036 0 0 1 1.436 1.415l2.438-2.4a2.876 2.876 0 0 0 0-4.113 2.986 2.986 0 0 0-4.176 0l-2.92 2.875a1.189 1.189 0 0 1-1.663 0 1.145 1.145 0 0 1 0-1.638l1.497-1.474Z" />
    <path d="M9.91 12.482A2.02 2.02 0 0 0 7.947 11c-1.121 0-2.03.895-2.03 2s.909 2 2.03 2c1.122 0 2.032-.895 2.032-2 0-.18-.024-.353-.07-.518Z" />
  </svg>
);
export default IconRouteSizeS;
